<script lang="ts">
  import { setContext } from "svelte"
  import { Client, setContextClient } from "@urql/svelte"
  import { getUrqlClient } from "website_script/lib/urql"
  import appStore from "website_script/stores/app"
  import { timesLoaded } from "website_script/stores/timesLoaded"
  import abTesting from "website_script/stores/abTesting"
  import { trackFunction } from "website_script/lib/tracking"
  import { isMobile } from "website_script/lib/Helpers"
  import type { Settings } from "website_script/types/settings"
  import type { Texts } from "website_script/types/texts"
  import type { Theme } from "website_script/types/theme"
  import type { DealerTheme } from "conversion_flows/shared/contexts/dealerTheme"
  import type { Config } from "website_script/types/common"

  export let settings: Settings
  setContext("settings", settings)

  export let texts: Texts
  setContext("texts", texts)

  export let theme: Theme

  const dealerTheme: DealerTheme = {
    brandPrimary: theme.accentColor,
    inversePrimary: theme.inverseAccentColor,
  }
  setContext("theme", theme)
  setContext("dealerTheme", dealerTheme)

  export let urqlClient: Client | undefined = undefined
  const _urqlClient = getUrqlClient({
    host: settings.iframeHost,
    locale: settings.locale,
  })
  setContextClient(urqlClient ?? _urqlClient)

  export let config: Config
  setContext("config", config)

  setContext("environment", {
    mobile: isMobile(),
    abTesting,
    timesLoaded,
    trackFunction,
  })

  setContext("appStore", appStore)
</script>

<slot />
